import React, { useState, useEffect } from 'react'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByReasonCodeDistribution
 * @desc Render Reason Code Distribution
 * @filterValues IReportsFilter
 */
const ByReasonCodeDistribution = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<
        {
            name: string
            value: number
            tooltipName?: string
        }[]
    >([])

    useEffect(() => {
        // Simulate loading
        setLoading(true)
        
        // Hardcoded data with requested changes
        const hardcodedData = [
            {
                name: 'MC 4855',
                value: 33,
                tooltipName: 'MC 4855: Goods or Services Not Received',
                pct: 15.35,
                description: 'Goods or Services Not Received',
                code: 'MC 4855'
            },
            {
                name: 'MC 4834',
                value: 31,
                tooltipName: 'MC 4834: Duplicate Processing',
                pct: 14.42,
                description: 'Duplicate Processing',
                code: 'MC 4834'
            },
            {
                name: 'MC 4853',
                value: 27,
                tooltipName: 'MC 4853: Cardholder Dispute Defective/Not As Described',
                pct: 12.56,
                description: 'Cardholder Dispute Defective/Not As Described',
                code: 'MC 4853'
            },
            {
                name: 'Visa 41',
                value: 27,
                tooltipName: 'Visa 41: Cancelled Recurring Transaction',
                pct: 12.56,
                description: 'Cancelled Recurring Transaction',
                code: 'Visa 41'
            },
            {
                name: 'Visa 10.4',
                value: 26,
                tooltipName: 'Visa 10.4: Unknown',
                pct: 12.09,
                description: 'Unknown',
                code: 'Visa 10.4'
            }
            // "Others" entry is excluded as per the original filtering
        ];
        
        // Simulate API delay
        setTimeout(() => {
            setData(hardcodedData);
            setLoading(false);
        }, 500);
    }, [filterValues]); // eslint-disable-line react-hooks/exhaustive-deps

    const colorPalette =
        clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="Reason Code Distribution">
            <PieChart
                data={data}
                loading={loading}
                colorPalette={colorPalette}
                testId="byReasonCodeDistribution"
                height={350}
                pieLabelLayout={'inside'}
            />
        </AccentArea>
    )
}

export default ByReasonCodeDistribution
